export default __webpack_public_path__ + "static/01_Didi-370735c74ee814e772ad66e0a2adfe4f.pdf";